interface IndexItem {
  title: string;
  count: string;
  desc: string;
  imageUrl: string;
  imageAlt: string;
}

const indexItems: IndexItem[] = [
  {
    title: '韩漫精选合集',
    count: '328部',
    desc: '恋爱甜宠、穿越重生、霸总题材……韩漫热门分类一网打尽。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20Korean%20manhwa%20covers%20arranged%20elegantly%2C%20romantic%20and%20dramatic%20themes%2C%20warm%20pink%20and%20gold%20color%20palette%2C%20clean%20modern%20layout%20with%20soft%20lighting%2C%20editorial%20quality%20digital%20art%2C%20minimalist%20composition%20with%20decorative%20elements&width=600&height=400&seq=index-01&orientation=landscape',
    imageAlt: '韩漫精选合集',
  },
  {
    title: '国漫玄幻殿堂',
    count: '215部',
    desc: '仙侠修真、武道纵横、神话传说……国漫的想象力没有边界。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20Chinese%20manhua%20covers%20with%20martial%20arts%20and%20fantasy%20themes%2C%20ink%20wash%20painting%20style%20with%20modern%20digital%20art%2C%20warm%20earthy%20brown%20and%20jade%20green%20palette%2C%20elegant%20traditional%20Chinese%20aesthetic%2C%20clean%20layout%2C%20editorial%20quality&width=600&height=400&seq=index-02&orientation=landscape',
    imageAlt: '国漫玄幻殿堂',
  },
  {
    title: '日漫热血联盟',
    count: '402部',
    desc: '少年Jump系、战斗热血、运动竞技……点燃你的青春之魂。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dynamic%20collection%20of%20Japanese%20manga%20covers%20featuring%20action%20and%20shonen%20themes%2C%20vibrant%20orange%20and%20red%20color%20scheme%2C%20energetic%20composition%20with%20speed%20lines%20and%20effects%2C%20clean%20modern%20layout%2C%20editorial%20quality%20digital%20art%20with%20professional%20design&width=600&height=400&seq=index-03&orientation=landscape',
    imageAlt: '日漫热血联盟',
  },
  {
    title: '校园青春物语',
    count: '186部',
    desc: '纯爱、友情、成长……那些关于青春的故事，永远看不够。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20soft%20and%20dreamy%20collection%20of%20school%20life%20manga%20and%20manhwa%20covers%2C%20cherry%20blossom%20and%20classroom%20themes%2C%20pastel%20pink%20and%20warm%20cream%20color%20palette%2C%20gentle%20and%20nostalgic%20atmosphere%2C%20clean%20layout%2C%20editorial%20quality%20digital%20illustration&width=600&height=400&seq=index-04&orientation=landscape',
    imageAlt: '校园青春物语',
  },
  {
    title: '悬疑推理剧场',
    count: '143部',
    desc: '烧脑反转、心理博弈、犯罪追踪……高智商漫画爱好者的天堂。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20and%20atmospheric%20collection%20of%20thriller%20and%20mystery%20manga%20covers%2C%20dark%20warm%20amber%20and%20deep%20shadow%20color%20palette%2C%20dramatic%20lighting%20with%20silhouettes%20and%20clues%2C%20clean%20modern%20layout%2C%20editorial%20quality%20digital%20art%20with%20suspenseful%20composition&width=600&height=400&seq=index-05&orientation=landscape',
    imageAlt: '悬疑推理剧场',
  },
  {
    title: '奇幻异世界之旅',
    count: '267部',
    desc: '剑与魔法、异世界转生、史诗冒险……带你穿梭于万千幻想世界。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20fantastical%20collection%20of%20isekai%20and%20fantasy%20manga%20covers%2C%20magical%20elements%20with%20castles%20and%20dragons%2C%20warm%20golden%20and%20emerald%20green%20color%20palette%2C%20dreamy%20and%20adventurous%20atmosphere%2C%20clean%20modern%20layout%2C%20editorial%20quality%20digital%20illustration&width=600&height=400&seq=index-06&orientation=landscape',
    imageAlt: '奇幻异世界之旅',
  },
  {
    title: '治愈日常漫选',
    count: '159部',
    desc: '美食、萌宠、慢生活……在忙碌的生活中，给你一片安静的温暖。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20cozy%20and%20heartwarming%20collection%20of%20slice%20of%20life%20manga%20covers%2C%20food%20and%20cats%20and%20everyday%20scenes%2C%20warm%20cream%20and%20soft%20coral%20color%20palette%2C%20gentle%20and%20comforting%20atmosphere%2C%20clean%20layout%2C%20editorial%20quality%20digital%20art%20with%20minimalist%20design&width=600&height=400&seq=index-07&orientation=landscape',
    imageAlt: '治愈日常漫选',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">专题合集</h2>
          <p className="text-sm text-foreground-500">按题材分类探索，精准找到你的口味</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 rounded-full bg-background-50/90 text-xs font-medium text-primary-700">
                    {item.count}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}